export function daysInMonth(year, month, workingHours) {
  let date = new Date(year, month, 1),
      days = [],
      today = (new Date()).setHours(0, 0, 0, 0)


  while( date.getMonth() === month ) {
    const disabled = (date < today)

    days.push({
      date: new Date(date),
      disabled
    })

    date.setDate(date.getDate() + 1)
  }
  return days
}

export function daysUntil(year, month, targetWeekday){
  let date = new Date(year, month, 1),
      days = []

  while( date.getDay() !== targetWeekday ) {
    date.setDate(date.getDate() - 1)

    days.push({
      date: new Date(date),
      disabled: true
    })
  }

  return days.reverse()
}

export const totalAvailableSlots = (timeslot, service) => {
  const additionalStaffsIds = service.additionalStaff ? service.additionalStaff.map(s => s.id) : []

  return timeslot.staffs.reduce((acc, staff) => {
    if(additionalStaffsIds.indexOf(staff.id) > -1) {
      return acc
    }
    return acc + staff.availableSlots
  }, 0)
}
